import commonModel from './common'
import { projectType } from '@/util/global'
import { ElMessage } from 'element-plus'
import { Decrypt } from '@/api/sign'
import CryptoJS from 'crypto-js'

// 初始化更新系统时间
export const getServerTime = async () => {
  try {
    const clientTime = Date.now()
    const res = await commonModel.time({ ts: clientTime }, projectType().name)
    projectType().serverTime = res.data.server_time_ms
    projectType().differenceTime = res.data.server_time_ms - clientTime
    return res.data.server_time_ms
  } catch (error) {
    ElMessage({
      message: error,
      center: true,
      offset: 200,
      type: 'error',
      customClass: 'ElMessageIndex',
    })
    throw error
  }
}

// 初始化
export const init = async () => {
  const data = {}
  await commonModel
    .init(data, projectType().name)
    .then((res) => {
      if (res && res.data !== '' && res.data !== undefined) {
        // 写入appkey
        let { app_key, pkey, skey } = JSON.parse(
          Decrypt(
            res.data.gw_data.data,
            CryptoJS.MD5(res.data.gw_data.token + projectType().aesKey).toString(),
            CryptoJS.MD5(res.data.gw_data.token + projectType().aesKey)
              .toString()
              .slice(-16),
          ),
        )
        ;((projectType().appKey = app_key),
          (projectType().publickey = pkey),
          (projectType().privateKey = skey))
      }
    })
    .catch((error) => {
      ElMessage({
        message: '【init】' + error,
        center: true,
        offset: 200,
        type: 'error',
        customClass: 'ElMessageIndex',
      })
    })
}

// 获取栏目扩展字段
export const additi = async (id) => {
  const data = {
    columns_id: id,
  }
  const res = await commonModel.additi(data, projectType().name)
  if (res.code == 200) {
    return res
  } else {
    ElMessage({
      message: res.msg,
      center: true,
      offset: 200,
      type: 'error',
      customClass: 'ElMessageIndex',
    })
  }
}

// 获取文章列表
export const articles = async (id) => {
  const data = {
    columns_id: id,
    page: '1',
    size: '10',
  }
  const res = await commonModel.articles(data, projectType().name)
  if (res.code == 200) {
    return res
  } else {
    ElMessage({
      message: res.msg,
      center: true,
      offset: 200,
      type: 'error',
      customClass: 'ElMessageIndex',
    })
  }
}

// 获取栏目列表
export const columns = async (id) => {
  // const data = {
  //   parent_id: id,
  // }
  // 不传ID就会返回所有大栏目的信息
  const data = {}
  if (id) data.parent_id = id
  const res = await commonModel.columns(data, projectType().name)
  if (res.code == 200) {
    return res
  } else {
    ElMessage({
      message: res.msg,
      center: true,
      offset: 200,
      type: 'error',
      customClass: 'ElMessageIndex',
    })
  }
}

// 获取文章详情
export const details = async (columnsId, id) => {
  /*
        参数说明
        columns_id  文章栏目id
        id  当前文章id
    */
  const data = {
    columns_id: columnsId,
    id: id,
  }
  const res = await commonModel.details(data, projectType().name)
  if (res.code == 200) {
    return res
  } else {
    ElMessage({
      message: res.msg,
      center: true,
      offset: 200,
      type: 'error',
      customClass: 'ElMessageIndex',
    })
  }
}

// 获取文章列表(含子栏目) page代表页数 size 代表一次请求几条数据
export const articlesSubList = async (id, page, size) => {
  const data = {
    columns_id: id,
    page: page || 1,
    size: size || 10,
  }
  const res = await commonModel.articlesSubList(data, projectType().name)
  if (res.code == 200) {
    return res
  } else {
    ElMessage({
      message: res.msg,
      center: true,
      offset: 200,
      type: 'error',
      customClass: 'ElMessageIndex',
    })
  }
}
